/**
 * 特約・約款情報
 */
export class SpecialProvision {
	// private変数 -----------------------------------------------------------------------------------------------------------------------------------------------------------------
	private m_SpecialProvision: string = null; // 特約・約款
	// -----------------------------------------------------------------------------------------------------------------------------------------------------------------------------

	// プロパティ -------------------------------------------------------------------------------------------------------------------------------------------------------------------
	/** 特約・約款 */
	public get specialProvision(): string { return this.m_SpecialProvision; } public set specialProvision(specialProvision: string) { this.m_SpecialProvision = specialProvision; }
	// ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

	// コンストラクタ ----------------------------------------------------------------------------------------------------------------------------------------------------------------
	constructor() { }
	// ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
}